// import React, { useEffect } from "react";
// import AOS from "aos";
// import "aos/dist/aos.css";

// const WelcomeSection = () => {
//   useEffect(() => {
//     AOS.init({ duration: 1000, once: true, easing: "ease-in-out" });
//   }, []);

//   return (
//     <div id="welcomeSection" >
//       <section className="py-5 position-relative overflow-hidden">
//       <div className="container">
//         <div className="text-center mb-5">
//           {/* Heading */}
//           <h2
//             className="fw-bold display-5 text-primary mb-3"
//             data-aos="fade-up"
//           >
//            <span className="text-secondary" >Welcome to</span>  Corbiltek
//           </h2>

//           {/* Subheading */}
//           <h5
//             className="text-secondary fw-semibold mb-4"
//             data-aos="fade-up"
//             data-aos-delay="200"
//           >
//             Your Partner in Construction Excellence
//           </h5>
//         </div>

//         {/* Description */}
//         <div className="row justify-content-center">
//           <div className="col-lg-10 col-md-11">
//             <p
//               className="text-muted fs-5 lh-lg text-center"
//               data-aos="fade-up"
//               data-aos-delay="400"
//             >
//               <em>
//                 Build with confidence through clear designs, seamless permits,
//                 and expert guidance at every step. As a{" "}
//                 <strong>Startup India–recognised</strong> and{" "}
//                 <strong>Kerala Startup Mission–approved</strong> company, we
//                 offer dependable drawings, smooth customer support, and smart
//                 solutions that make your construction journey simpler, faster,
//                 and truly stress-free.
//               </em>
//             </p>
//           </div>
//         </div>
//       </div>
//     </section>
//     </div>
    
//   );
// };

// export default WelcomeSection;


import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

const WelcomeSection = () => {
  useEffect(() => {
    AOS.init({ duration: 1200, once: true, easing: "ease-in-out" });
  }, []);

  return (
    <section
      id="welcomeSection"
      className="py-5 position-relative overflow-hidden"
      style={{
        // background: "linear-gradient(180deg, #F4ECFF 0%, #F8F2FF 100%)",
      }}
    >
      <div className="container text-center mt-5 mb-5">
        {/* === Heading === */}
        <h2
          data-aos="fade-up"
          className="fw-bold mb-3 display-5"
          style={{
            color: "#3F4868",
            textShadow: "0 3px 8px rgba(63,72,104,0.2)",
            letterSpacing: "1px",
          }}
        >
          <span
            style={{
              display: "block",
              color: "#6B83A4",
              fontSize: "1.4rem",
              marginBottom: "10px",
              fontWeight: "600",
              letterSpacing: "2px",
              textTransform: "uppercase",
            }}
          >
            Welcome to
          </span>
          <span
            style={{
              background:
                "linear-gradient(90deg, #3F4868, #6B83A4, #3F4868)",
              WebkitBackgroundClip: "text",
              WebkitTextFillColor: "transparent",
            }}
          >
            Corbiltek
          </span>
        </h2>

        {/* === Subheading === */}
        <h5
          className="fw-semibold mb-5"
          data-aos="fade-up"
          data-aos-delay="200"
          style={{
            color: "#4b5f71",
            fontSize: "1.3rem",
            letterSpacing: "0.5px",
            textShadow: "0 1px 4px rgba(75,95,113,0.15)",
          }}
        >
          Your Partner in Construction Excellence
        </h5>

        {/* === Description === */}
        <div
          className="col-lg-10 col-md-11 mx-auto"
          data-aos="fade-up"
          data-aos-delay="400"
        >
          <p
            className="fs-5 lh-lg text-center mx-auto"
            style={{
              color: "#3F4868",
              // backgroundColor: "#E1D9EC",
              // borderRadius: "16px",
              padding: "20px 30px",
              // boxShadow: "0 4px 10px rgba(63,72,104,0.1)",
              fontStyle: "italic",
            }}
          >
            Build with confidence through clear designs, seamless permits, and
            expert guidance at every step. As a{" "}
            <strong style={{ color: "#6B83A4" }}>
              Startup India–recognised
            </strong>{" "}
            and{" "}
            <strong style={{ color: "#6B83A4" }}>
              Kerala Startup Mission–approved
            </strong>{" "}
            company, we offer dependable drawings, smooth customer support, and
            smart solutions that make your construction journey simpler, faster,
            and truly stress-free.
          </p>
        </div>
      </div>

      {/* Decorative background elements */}
      <div
        className="position-absolute rounded-circle"
        style={{
          width: "220px",
          height: "220px",
          top: "-70px",
          left: "-70px",
          background: "radial-gradient(circle, #E1D3F2 0%, transparent 70%)",
          opacity: 0.5,
        }}
      />
      <div
        className="position-absolute rounded-circle"
        style={{
          width: "260px",
          height: "260px",
          bottom: "-100px",
          right: "-100px",
          background: "radial-gradient(circle, #B2BEB5 0%, transparent 70%)",
          opacity: 0.4,
        }}
      />
    </section>
  );
};

export default WelcomeSection;
